import {css} from 'styled-components';

import {fonts, fontWeights} from './fontStyles';

/*
 * Styles.
 */

export function basicMarkdownStyle() {
  return css`
    strong {
      font-weight: ${fontWeights.bold};
    }

    em {
      font-style: italic;
    }

    s {
      text-decoration: line-through;
    }

    code {
      padding: 2px;
      margin: -2px 0;

      border-radius: 4px;
      border: 1px solid ${(p) => p.theme.palette.blue.shade20};
      color: ${(p) => p.theme.interactiveText};
      font-family: ${fonts.monospace};
      background-color: ${(p) => p.theme.palette.blue.shade10};
    }

    a {
      cursor: pointer;
      color: ${(p) => p.theme.interactiveText};
      font-weight: ${fontWeights.medium};
    }
  `;
}
